module.exports = __webpack_public_path__ + "static/media/q4.c0b706a5.png";